
<template>
    <div class="progress-bar mb-sm-5 mb-4 px-sm-0 px-2">
        <ul>

            <li v-bind:class="{complete: isComplete(1), 'current' : isCurrent(1)}">
                <span class="d-none d-lg-block">Dates &amp; Guests</span>
                <span class="d-lg-none number">1</span>
                <a v-if="isComplete(1)"
                   v-bind:href="getPath('spa_day_search')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(2), 'current' : isCurrent(2)}">
                <span class="d-none d-lg-block">Treatments</span>
                <span class="d-lg-none number">2</span>
                <a v-if="isComplete(2)"
                   v-bind:href="getPath('spa_day_treatments', 1)">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(3), 'current' : isCurrent(3)}">
                <span class="d-none d-lg-block">Add ons</span>
                <span class="d-lg-none number">3</span>
                <a v-if="isComplete(3)"
                   v-bind:href="getPath('spa_day_add_ons')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(4), 'current' : isCurrent(4)}">
                <span class="d-none d-lg-block">Details</span>
                <span class="d-lg-none number">4</span>
                <a v-if="isComplete(4)"
                   v-bind:href="getPath('spa_day_details')">Edit</a>
            </li>
            <li v-bind:class="{complete: isComplete(5), 'current' : isCurrent(5)}">
                <span class="d-none d-lg-block">Payment</span>
                <span class="d-lg-none number">5</span>
                <a v-if="isComplete(5)"
                   v-bind:href="getPath('spa_day_payment')">Edit</a>
            </li>
        </ul>

    </div>
</template>

<script>
    import { store } from '../store/index';

    export default {
        name: 'SpaDayProgressBar',
        computed: {
            currentStep() {
                return this.$route.name;
            },
            session() {

                return store.getters.session
            }
        },
        data() {
            return {
                paths: [
                    {
                        routeName: 'spa_day_search',
                        step: 1
                    },
                    {
                        routeName: 'spa_day_guests',
                        step: 1
                    },
                    {
                        routeName: 'spa_day_arrival_time',
                        step: 1
                    },
                
                    {
                        routeName: 'spa_day_dining',
                        step: 1
                    },
                    {
                        routeName: 'spa_day_garden',
                        step: 2
                    },
                    {
                        routeName: 'spa_day_treatments',
                        step: 2
                    },
                    {
                        routeName: 'spa_day_treatment_times',
                        step: 2
                    },
                    {
                        routeName: 'spa_day_add_ons',
                        step: 3
                    },
                    {
                        routeName: 'spa_day_details',
                        step: 4
                    },
                    {
                        routeName: 'spa_day_summary',
                        step: 5
                    }
                    ,
                    {
                        routeName: 'spa_day_payment',
                        step: 5
                    }
                ]

            }
        },
        methods: {
            getPath: function (routeName, leg) {
                var route = {
                    name: routeName,
                    params: {
                        id: this.session.Id
                    }
                };


                let props = this.$router.resolve(route);

                return props.href;

            },
            isComplete: function (step) {
                var path = this.paths.find(item => item.routeName == this.currentStep);
                var pathStep = path.step;
                return step < pathStep;
            },
            isCurrent: function (step) {
                var path = this.paths.find(item => item.routeName == this.currentStep);
                var pathStep = path.step;
                return step == pathStep;
            }
        }
    }
</script>

<style scoped>
    .progress-bar {
        width: 100%;
        display: flex;
        justify-content: center;
        max-width: 805px;
        margin: 0 auto;
    }

        .progress-bar ul {
            display: flex;
            flex-direction: row;
            padding: 0;
            margin: 0;
            width: 100%;
            justify-content: space-between;
            list-style: none;
        }

            .progress-bar ul li {
                display: flex;
                flex-direction: column;
                text-align: center;
                position: relative;
                text-transform: uppercase;
                font-weight: bold;
            }

                .progress-bar ul li span {
                    font-size: 14px;
                    color: #1a1a1a;
                    position: relative;
                }

                .progress-bar ul li a {
                    color: #a2905b;
                    font-size: 12px;
                }

                /*.progress-bar ul li.current:after {
                    position: absolute;
                    content: '';
                    bottom: -8px;
                    width: 60px;
                    background: #a2905b;
                    height: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                }*/

                .progress-bar ul li.current span:after {
                    position: absolute;
                    content: '';
                    bottom: -8px;
                    width: 60px;
                    background: #a2905b;
                    height: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                }

                .progress-bar ul li.complete span {
                    color: #7d7f80;
                    position: relative;
                }

                    .progress-bar ul li.complete span:after {
                        display: block;
                        content: '';
                        height: 1px;
                        width: 20px;
                        background: #7d7f80;
                        right: -55px;
                        top: 12px;
                        position: absolute;
                    }

        .progress-bar .number {
            width: 40px;
            height: 40px;
            border: solid 1px rgba(0,0,0,0.2);
            border-radius: 50%;
            line-height: 40px;
            margin-bottom: 10px
        }


        @media(max-width: 991px){
            .progress-bar .number:after {
                display: none;
            }
        }


        .progress-bar ul li.complete .number {
            border: solid 1px #a18f5b;
        }

        .progress-bar ul li.current .number {
            border: solid 1px #a18f5b;
            background: #fff;
        }


    @media (max-width: 991px) {
        .progress-bar ul li.complete span:after,
        .progress-bar ul li.current:after {
            display: none;
        }
    }
</style>